import React from 'react'
import Container from '@material-ui/core/Container'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import Divider from '@material-ui/core/Divider'


const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: '10px',
        marginBottom: '32px',
    },
    title: {
        color: "#e1465e",
        textTransform: "uppercase",
        fontWeight: 300,
        fontSize: '26px'

    }
}));

const CustomExamFeedback = ({ filtros }) => {
    const { anos, dificuldades, especialidades, instituicoes, perguntasAleatorias, respostasAleatorias, quantidadeDePerguntas } = filtros
    const classes = useStyles()

    return (
        <Container className={classes.root}>
            <Box marginTop={'12px'} display={'flex'} justifyContent={'center'}>
                <Typography className={classes.title}>Prova Personalizada</Typography>
            </Box>
            <Box>
                {instituicoes.length !== 0 && <Typography><b>Instituições:</b> {instituicoes.join(' , ')}</Typography>}
            </Box>
            <Box>
                {especialidades.length !== 0 && <Typography><b>Especialidades:</b> {especialidades.join(' , ')}</Typography>}
            </Box>
            <Box>
                {quantidadeDePerguntas && <Typography><b>Quantidade de Perguntas:</b> {quantidadeDePerguntas}</Typography>}
            </Box>
            <Box>
                {anos.length !== 0 && <Typography><b>Anos:</b> {anos.join(' , ')}</Typography>}
            </Box>
            <Box>
                {dificuldades.length !== 0 && <Typography><b>Dificuldades:</b> {dificuldades.join(' , ')}</Typography>}
            </Box>
            <Box marginBottom={'24px'}>
                {perguntasAleatorias && respostasAleatorias ? <Typography><b>Trazer Aleatoriamente: </b> Perguntas e Respostas</Typography> : perguntasAleatorias && !respostasAleatorias ? <Typography><b>Trazer Aleatoriamente: </b> Perguntas</Typography> : !perguntasAleatorias && respostasAleatorias && <Typography><b>Trazer Aleatoriamente: </b> Respostas</Typography>}
            </Box>
            <Divider />
        </Container>
    )


}

export default CustomExamFeedback